<template>
    <ul class="d-flex flex-wrap align-items-center list-unstyled badgeShape">
        <li class="me-3" v-if="category && category.unit=='Box'" >
            <span class="font14 textDark textBold600"><b>{{calculate_sqft_price_()|toCurrency}}</b></span>/
            <span>sqft</span>
        </li>
        <li class="productDetailsPrice" >
            <span class="dollarPrice"><b>{{pPrice|toCurrency}}</b></span>/
            <span class="perprice" v-if="category && category.unit=='Box'">Box</span>
            <span class="perprice" v-else-if="uom">{{ uom }}</span>
            <span class="perprice" v-else>Piece</span>
        </li>
    </ul>
</template>
<script>
export default {
    name:"productPriceElement",
    props:{
        category:{},
        pPrice:{
            default:0,
        },
        sizeSet: {
            type: Object,
            default: () => {
                box_sqft: 0
                height_size: 0
                minimum_unit: 0
                unit: 0
                width_size: 0
            }
        },
    },
    methods: {
        calculate_sqft_price_(){
            let sqftPrice=0
            if(this.sizeSet){
           // let sqft= (this.sizeSet.width_size * this.sizeSet.height_size) * this.sizeSet.unit
            sqftPrice=(this.pPrice/this.sizeSet.box_sqft)
            }
            return sqftPrice;
        }
    },
}
</script>
